import styles from './ProfileHeader.module.css'
import {useTelegramUserStore} from "../../../store/useTelegramUserStore.ts";

const ProfileHeader = () => {

    const photo_url = useTelegramUserStore((state) => state.user?.photo_url);
    const name = useTelegramUserStore((state) => state.user?.username);

    return (
        <div className={styles.profileHeader}>
            <div className={styles.profileHeader__content}>
                <div className={styles.profileHeader__img}>
                    <img src={photo_url} alt="Profile picture"/>
                </div>
                <div className={styles.profileHeader__name}>
                    {name}
                </div>
            </div>
        </div>
    )
}

export default ProfileHeader;